import React, { Component } from 'react';
import { Icon, Input, Row, Col, Tag } from 'antd';
import { Tag as TagApi } from '../services/api';
import Spinner from './Spinner';

export default class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            query: '',
            tags: [],
            selectedTags: [],
            focused: false,
            loading: {
                tags: false,
                search: false
            }
        };

        this.tagApi = new TagApi(props);
    }

    componentDidMount() {
        if (this.props.useTags) {
            this.fetchTags();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loading !== this.state.loading.search) {
            const { loading } = this.state;
            loading.search = nextProps.loading;
            this.setState({ loading });
        }
    }

    fetchTags = () => {
        const { loading } = this.state;
        loading.tags = true;
        this.setState({ loading });

        this.tagApi.list()
            .then(res => {
                loading.tags = false;
                this.setState({ tags: res.data.data, loading });
            })
            .catch(_ => {
                this.tagApi.retry({ cb: this.fetchTags });
            });
    }   

    search = (e) => {
        const { loading } = this.state;
        const query = e.target.value;
        if (query === '') {
            this.clear();
            return;
        }

        loading.search = true;
        this.setState({ query, loading });
        clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
            this.props.onSearch(query);
        }, 500);
    }

    searchByTag = (tag) => {
        const { selectedTags } = this.state;
        const index = selectedTags.findIndex(t => t === tag);
        if (index !== -1) {
            selectedTags.splice(index, 1);
        } else {
            selectedTags.push(tag);
        }

        this.setState({ selectedTags });
        this.props.onTagSearch(selectedTags);
    }

    clear = () => {
        this.setState({ query: '', selectedTags: [], focused: false });
        this.props.onClear();
    }

    clearTag = (tag) => {
        const { selectedTags } = this.state;
        const index = selectedTags.findIndex(t => t === tag);
        if (index !== -1) {
            selectedTags.splice(index, 1);
            this.setState({ selectedTags });
        }

        if (selectedTags.length > 0) {
            this.props.onTagSearch(selectedTags);
            return;
        }

        this.setState({ focused: false });
        this.props.onClear();
    }

    render() {
        const { placeholder, useTags } = this.props;
        const { query, loading, tags, selectedTags, focused } = this.state;
        let suffix = <Icon type="search" />
        if (loading.search) {
            suffix = <Icon type="loading" />
        } else if (query !== '') {
            suffix = <Icon type="close-circle" onClick={this.clear} />
        }
        
        return (
            <div style={{ marginBottom: '40px' }}>
                <Row type="flex" justify="space-around" align="middle">
                    <Col xs={24} sm={12}>
                        <Input
                            placeholder={placeholder}
                            onChange={this.search}
                            onFocus={() => this.setState({ focused: true })}
                            value={query}
                            suffix={suffix}
                            size="large"
                        />

                        {focused && useTags && (
                            <div style={{ marginTop: '20px' }}>
                                {selectedTags.length > 0 && (
                                    <div style={{ textAlign: 'center' }}>
                                        <h4>Nuvarande filtrering</h4>
                                        <Row type="flex" justify="center">                                        
                                            {selectedTags.map(t => (
                                                <Tag key={t} closable onClose={e => this.clearTag(t)} color="volcano">{t}</Tag>)
                                            )}
                                        </Row>    
                                    </div>
                                )}
                                
                                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <h4>Filtrera på taggar</h4>
                                    <Row type="flex" justify="center">
                                    <Spinner loading={loading.tags} />
                                    {tags.map(t => (                                        
                                        <Tag key={t.title} onClick={e => this.searchByTag(t.title)} color="volcano">{t.title}</Tag>)
                                    )}
                                </Row>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/components/Search.js